<nav class="navbar flex-row flex-nowrap justify-content-start">
  <ng-container *ngIf="layoutService.getSideNavState() | async">
    <button  style="width: 32px; height: 32px;"
            class="navbar-toggler border-0"
            mat-icon-button
            type="button"
            (click)="layoutService.expandSideNav()">
      <mat-icon style="transform: scaleX(-1);" class="text-white" fontSet="design">menu_open</mat-icon>
    </button>
    <span style="height: 1em; opacity: 0.15;"
          class="d-inline-block mr-3 align-middle border-start border-white"></span>
  </ng-container>

  <div class="navbar-collapse collapse d-flex flex-nowrap">
    <ul class="navbar-nav flex-row flex-nowrap text-white">
      <li class="nav-item" *ngIf="(layoutService.getOrgSelectVisibility() | async) && currOrg">
        <button class="px-0 fw-normal"
                mat-button
                [matMenuTriggerFor]="orgMenu"
                (menuOpened)="onOrgMenuTrigered()"
                (menuClosed)="onOrgMenuTrigered()"
                #orgMenuTrigger="matMenuTrigger">
          {{currOrg.alias}}
          <mat-icon class="ml-3 arrow"></mat-icon>
        </button>
        <mat-menu #orgMenu="matMenu">
          <ng-container
                        *ngFor="let organization of organizationService.organizations$ | async; trackBy: trackById">
            <button class="d-flex flex-nowrap align-items-center"
                    [class.active]="organization.id === currOrg.id"
                    mat-menu-item
                    (click)="setSelectedOrganization(organization)">
              <span class="text-truncate">
                {{organization.alias}}
              </span>
              <span class="ml-2" *ngIf="isTerminatedOrg(organization)">
                <app-status-badge color="secondary">
                  <ng-container i18n="@@global.label.terminated">Terminated</ng-container>
                </app-status-badge>
              </span>
            </button>
          </ng-container>
        </mat-menu>
      </li>
      <li class="nav-item fw-medium" *ngIf="(layoutService.getProjectelectVisibility() | async) && !!currProject">
        <mat-icon class="mr-1 align-middle fs-4" fontSet="design">stacks</mat-icon>
        <small>{{currProject.alias}}</small>
      </li>
    </ul>
    <ul class="navbar-nav flex-row flex-nowrap ml-auto text-white">
      <li class="nav-item">
        <button style="min-width: 0px;" class="px-0" mat-button [matMenuTriggerFor]="accountMenu">
          <mat-icon class="text-white" fontSet="design">account_circle</mat-icon>
        </button>
        <mat-menu #accountMenu="matMenu">
          <span mat-menu-item class="fs-5 fw-semibold pe-none" (click)="$event.stopPropagation();">
            {{account?.firstName}} {{account?.lastName}}
          </span>
          <a mat-menu-item routerLink="/core/account/profile" routerLinkActive="active">
            <ng-container i18n="@@global.menu.account.profile">
              Profile
            </ng-container>
          </a>
          <button mat-menu-item (click)="logout()">
            <ng-container i18n="@@global.menu.account.logout">
              Log Out
            </ng-container>
          </button>
        </mat-menu>
      </li>
    </ul>
  </div>
</nav>